// extracted by mini-css-extract-plugin
module.exports = {"component":"Link_component__LgFCJ","noHover":"Link_noHover__1BAs3"};